import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  Input,
  Optional
} from "@angular/core";
import {getCalendarCellsData} from "../../../shared/helpers/calculated";
import {INT_CALENDAR_DAYS_COLLECTION, INT_DAYS_IN_WEEK_TOKEN, INT_MONTH_IN_YEAR_TOKEN} from "../../../shared/tokens";
import {TCalendarCell} from "../../../shared/types";
import {DateControllerStateDirective} from "../../directives";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Component({
  selector: 'int-day-selector',
  templateUrl: './int-day-selector.component.html',
  styleUrls: ['./int-day-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntDaySelectorComponent {

  @Input() markWeekends = true;
  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;

  selected: TCalendarCell | null = null;
  shownWeeks = 6;
  cellsAmount = this.daysInWeek * this.shownWeeks;

  cells$: Observable<Array<TCalendarCell>> = this.controller?.changePluginState$
    .pipe(
      map((date) => {
        return date ? this.generateCellsByDate(date) : [];
      })
    )

  constructor(
    @Inject(INT_CALENDAR_DAYS_COLLECTION) private readonly days: Array<string>,
    @Inject(INT_DAYS_IN_WEEK_TOKEN) private readonly daysInWeek: number,
    @Inject(INT_MONTH_IN_YEAR_TOKEN) private readonly monthInYear: number,
    @Optional()
    @Inject(DateControllerStateDirective) private readonly controller: DateControllerStateDirective,
  ) {

    if(!this.controller) {
      console.warn('Please provide intDateStateController [use DateControllerStateDirective]')
    }
  }

  get daysCollection() {
    return this.days;
  }

  get selectedDates() {
    return this.controller.onlyValidSelectDates();
  }

  get pluginState() {
    return this.controller.pluginDateStateForNavigation;
  }

  @HostListener('mouseleave')
  mouseleave() {
    this.controller.hoveredDate(null);
  }

  generateCellsByDate(date: Date) {
    const m = date.getMonth();
    const y = date.getFullYear();
    return ((m !== null && m !== undefined) && y)
      ? getCalendarCellsData(m, y, this.cellsAmount, this.monthInYear)
      : [];
  }

  onSelect(date: Date) {
    this.controller.set(date);
  }
}
